import { publicApiGet } from '../utils/api';
import { Game } from '../types/interfaces';

export const gamesApi = {
  getRandom: (limit: number = 8, sportId?: number, leagueId?: number): Promise<Game[]> => {
    const params = new URLSearchParams();
    params.append('limit', limit.toString());
    if (sportId !== undefined) params.append('sport_id', sportId.toString());
    if (leagueId !== undefined) params.append('league_id', leagueId.toString());
    return publicApiGet<Game[]>(`/games/random?${params.toString()}`);
  },

  getFeed: (limit: number = 8, sportId?: number, leagueId?: number, live?: boolean): Promise<Game[]> => {
    const params = new URLSearchParams();
    params.append('limit', limit.toString());
    if (sportId !== undefined) params.append('sport_id', sportId.toString());
    if (leagueId !== undefined) params.append('league_id', leagueId.toString());
    if (live) params.append('live', 'true');
    return publicApiGet<Game[]>(`/games/feed?${params.toString()}`);
  },
};
